import { FixedTextArea } from 'pages/wizard/styles';

const FixedTextAreaComponent: React.FunctionComponent<{
  value: any;
  propertyName: string;
  onChangeEpd: any;
  disabled: boolean;
  style?: any;
}> = ({ value, propertyName, onChangeEpd, disabled, style }) => {
  return (
    <FixedTextArea
      defaultValue={value}
      disabled={disabled === true}
      onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
        e.currentTarget.value !== value && onChangeEpd(propertyName, e.currentTarget.value)
      }
      style={style}
    />
  );
};

export default FixedTextAreaComponent;
